/**
 * Espejo del catálogo de permisos del backend (`api/src/shared/permissions/permissionKeys.ts`).
 * Agrupa los permisos por módulo para el árbol de la pantalla de Gestión de Permisos.
 * Las etiquetas se resuelven por i18n (`permissions.modules.*` y `permissions.keys.*`).
 */

export type PermissionModuleId =
  | 'dashboard'
  | 'metrics'
  | 'reports'
  | 'communications'
  | 'assistants'
  | 'permissions';

export interface PermissionModule {
  id: PermissionModuleId;
  keys: string[];
}

export const PERMISSION_MODULES: PermissionModule[] = [
  { id: 'dashboard', keys: ['dashboard.view'] },
  {
    id: 'metrics',
    keys: [
      'metrics.turnos',
      'metrics.pacientes',
      'metrics.caja',
      'metrics.profesionales',
      'metrics.recurrencia',
      'metrics.no_volvieron',
      'metrics.calidad',
      'metrics.plan_billing',
      'metrics.plan_recaudacion',
      'metrics.ranking_planes',
      'metrics.tendencia',
    ],
  },
  { id: 'reports', keys: ['reports.view', 'reports.export', 'reports.compare'] },
  { id: 'communications', keys: ['communications.view', 'communications.manage'] },
  { id: 'assistants', keys: ['assistants.view', 'assistants.manage'] },
  { id: 'permissions', keys: ['permissions.manage'] },
];

export const ALL_PERMISSION_KEYS: string[] = PERMISSION_MODULES.flatMap((m) => m.keys);

/** Clave i18n para el label de un módulo. */
export function moduleLabelKey(id: PermissionModuleId): string {
  return `permissions.modules.${id}`;
}

/** Clave i18n para el label de un permiso (ej. `metrics.turnos` → `permissions.keys.metrics.turnos`). */
export function permissionLabelKey(key: string): string {
  return `permissions.keys.${key}`;
}
